/* Little Rick in-house reviews: load more, search, topics, sort, filters, helpful votes, media viewer.
   Data = Worker-built JSON on cdn.shopify.com. No dependencies. Card markup mirrors snippets/lr-rv-card.liquid. */
(() => {
  // Keep in sync with TOPICS in the Worker (src/reviews.js).
  const TOPICS = { taste: /tast|flavou?r|delicious|yum/i, refreshing: /refresh|crisp|thirst/i, relaxing: /relax|calm|chill|unwind|stress|anxi/i,
    sleep: /sleep/i, 'instead-of-alcohol': /alcohol|booze|sober|hangover|wine|beer|cocktail/i, 'low-sugar': /sugar|calorie/i,
    value: /price|value|worth|cheap|expens|money/i, delivery: /deliver|arriv|shipping|dispatch|packag/i };
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (u, w) => u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '';
  const stars = (n, h) => `<span class="lr-rv-sr" style="--rv-h:${h}px"><span class="oke-sr-stars lr-rv-stars" role="img" aria-label="Rated ${n} out of 5 stars" style="--rv-pct:${n * 20}%"></span></span>`;
  const store = { get(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch { return []; } }, set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} } };
  const votes = new Set(store.get('lr-rv-helpful'));
  const cache = {};
  const load = url => (cache[url] ||= fetch(url).then(r => { if (!r.ok) throw new Error(r.status); return r.json(); }));

  function when(iso, uk) {
    const days = Math.floor((Date.now() - Date.parse(iso + 'T12:00:00Z')) / 86400000);
    if (days < 1) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 7) return days + ' days ago';
    return new Date(iso + 'T12:00:00Z').toLocaleDateString(uk ? 'en-GB' : 'en-US', uk ? { day: 'numeric', month: 'short', year: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function mark(text, q) {
    const t = esc(text);
    if (!q) return t;
    const rx = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
    return t.replace(rx, '<mark>$1</mark>');
  }
  function card(r, uk, products, q) {
    const media = (r.m || []).slice(0, 4).map(m => `<button type="button" class="${m.k === 'v' ? 'is-v' : ''}" data-full="${esc(m.u)}" data-kind="${m.k}" aria-label="Open customer ${m.k === 'v' ? 'video' : 'photo'}"><img src="${esc(m.k === 'v' ? m.p : sized(m.u, 160))}" alt="" width="72" height="72" loading="lazy" decoding="async"></button>`).join('');
    const pt = r.o ? r.pl : (products && r.p ? products[r.p] : '');
    const other = r.o === 'US' && uk ? ' · US customer' : r.o === 'UK' && !uk ? ' · UK customer' : '';
    const av = r.av ? `<img class="lr-rv-card__av" src="${esc(r.av)}" alt="" width="36" height="36" loading="lazy">` : `<span class="lr-rv-card__av" aria-hidden="true">${esc((r.a || 'L').trim().charAt(0).toUpperCase())}</span>`;
    const voted = votes.has(r.i);
    return `<li class="lr-rv-card" data-rv="${esc(r.i)}"><div class="lr-rv-card__who">${av}<div class="lr-rv-card__name"><b>${esc(r.a)}</b><span class="lr-rv-card__meta">${r.v ? '<span class="lr-rv-card__ver">✓ Verified buyer</span>' : ''}${other}</span></div><time class="lr-rv-card__date" datetime="${esc(r.d)}">${esc(when(r.d, uk))}</time></div>`
      + stars(r.r, 18)
      + (pt ? `<p class="lr-rv-card__rev">Reviewing <b>${esc(pt)}</b>${r.vn && !r.o ? ' · ' + esc(r.vn) : ''}</p>` : '')
      + (r.t ? `<h3>${mark(r.t, q)}</h3>` : '') + (r.b ? `<p class="lr-rv-card__body">${mark(r.b, q)}</p>` : '')
      + (media ? `<div class="lr-rv-card__media">${media}</div>` : '')
      + (r.rp ? `<div class="lr-rv-card__reply"><strong>Reply from Little Rick</strong>${esc(r.rp.b)}</div>` : '')
      + `<div class="lr-rv-card__foot"><button type="button" class="lr-rv-card__help" data-helpful="${esc(r.i)}" aria-pressed="${voted}">👍 Helpful${r.h > 0 ? ` <span>${r.h}</span>` : ''}</button></div></li>`;
  }

  // "Read more" only where the body is actually clamped.
  function clampButtons(root) {
    root.querySelectorAll('.lr-rv-card__body:not([data-c])').forEach(p => {
      p.dataset.c = 1;
      if (p.scrollHeight > p.clientHeight + 4) {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'lr-rv-card__more'; b.textContent = 'Read more';
        b.onclick = () => { const open = p.classList.toggle('is-open'); b.textContent = open ? 'Show less' : 'Read more'; };
        p.after(b);
      }
    });
  }

  function viewer(root) {
    const dlg = root.querySelector('[data-viewer]'), body = root.querySelector('[data-viewer-body]');
    if (!dlg) return () => {};
    const open = (u, k) => {
      body.innerHTML = k === 'v' ? `<video src="${esc(u)}" controls autoplay playsinline></video>` : `<img src="${esc(sized(u, 1400))}" alt="Customer photo">`;
      dlg.showModal();
    };
    dlg.addEventListener('close', () => { body.innerHTML = ''; });
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    root.addEventListener('click', e => { const b = e.target.closest('[data-full]'); if (b) open(b.dataset.full, b.dataset.kind); });
    return open;
  }

  function helpful(root) {
    root.addEventListener('click', async e => {
      const b = e.target.closest('[data-helpful]');
      if (!b || votes.has(b.dataset.helpful)) return;
      votes.add(b.dataset.helpful); store.set('lr-rv-helpful', [...votes].slice(-300));
      b.setAttribute('aria-pressed', 'true');
      const span = b.querySelector('span'); const n = (span ? Number(span.textContent) : 0) + 1;
      b.innerHTML = `👍 Helpful <span>${n}</span>`;
      fetch('/apps/trade/reviews/helpful', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ i: b.dataset.helpful }) }).catch(() => {});
    });
  }

  function init(root) {
    const list = root.querySelector('[data-list]'), more = root.querySelector('[data-more]'), status = root.querySelector('[data-status]');
    const sort = root.querySelector('[data-sort]'), search = root.querySelector('[data-search]'), uk = root.dataset.uk === 'true';
    const products = root.querySelector('[data-products]') ? JSON.parse(root.querySelector('[data-products]').textContent || 'null') : null;
    const open = viewer(root);
    helpful(root);
    let shown = Number(root.dataset.shown) || list.children.length, stars = 0, group = '', topic = '', media = false, q = '', all = null;
    const PAGE = 10;
    const filtered = () => !!(stars || group || topic || media || q || (sort && sort.value !== 'recent'));
    const ordered = rs => {
      const ql = q.toLowerCase();
      let out = rs.filter(r => (!stars || r.r === stars) && (!group || r.g === group) && (!media || r.m)
        && (!topic || TOPICS[topic].test(`${r.t} ${r.b}`)) && (!ql || `${r.t} ${r.b} ${r.a}`.toLowerCase().includes(ql)));
      const v = sort ? sort.value : 'recent';
      if (v === 'high') out = [...out].sort((a, b) => b.r - a.r || b.d.localeCompare(a.d));
      if (v === 'low') out = [...out].sort((a, b) => a.r - b.r || b.d.localeCompare(a.d));
      if (v === 'helpful') out = [...out].sort((a, b) => (b.h || 0) - (a.h || 0) || (b.m ? 1 : 0) - (a.m ? 1 : 0) || b.d.localeCompare(a.d));
      return out;
    };
    async function data(needAll) {
      if (all) return all;
      const first = await load(root.dataset.srcFirst);
      if (!needAll && (!first.more || shown + PAGE <= first.reviews.length)) return first.reviews;
      all = root.dataset.srcFull ? (await load(root.dataset.srcFull)).reviews : first.reviews;
      return all;
    }
    async function render(append) {
      status.textContent = 'Loading reviews…';
      try {
        const rs = ordered(await data(filtered()));
        const from = append ? shown : 0, to = append ? shown + PAGE : Math.max(PAGE, filtered() ? PAGE : shown);
        const html = rs.slice(from, to).map(r => card(r, uk, products, q)).join('');
        if (append) list.insertAdjacentHTML('beforeend', html); else list.innerHTML = html;
        list.querySelectorAll('.lr-rv-card:not(.is-new)').forEach((c, i) => { if (i >= from) c.classList.add('is-new'); });
        shown = Math.min(to, rs.length);
        status.textContent = rs.length ? (filtered() ? `${rs.length} matching review${rs.length === 1 ? '' : 's'}` : '') : 'No reviews match that yet. Try another filter.';
        if (more) more.hidden = shown >= rs.length;
        clampButtons(list);
      } catch (e) { status.textContent = 'Reviews couldn’t load. Please refresh the page.'; }
    }
    const refilter = () => { render(false); };
    more?.addEventListener('click', () => render(true));
    sort?.addEventListener('change', refilter);
    let t; search?.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => { q = search.value.trim(); refilter(); }, 250); });
    const toggle = (sel, getter, setter) => root.querySelectorAll(sel).forEach(b => b.addEventListener('click', () => {
      const val = getter(b); setter(val);
      root.querySelectorAll(sel).forEach(x => x.setAttribute('aria-pressed', String(x === b && !!val)));
      refilter();
    }));
    toggle('[data-stars]', b => (stars === Number(b.dataset.stars) ? 0 : Number(b.dataset.stars)), v => { stars = v; });
    toggle('[data-topic]', b => (topic === b.dataset.topic ? '' : b.dataset.topic), v => { topic = v; });
    toggle('[data-group]', b => b.dataset.group, v => { group = v; });
    root.querySelector('[data-media]')?.addEventListener('click', e => { media = !media; e.currentTarget.setAttribute('aria-pressed', String(media)); refilter(); });
    root.querySelectorAll('[data-group=""]').forEach(b => b.setAttribute('aria-pressed', 'true'));
    // Photo wall in the summary opens that review's first photo/video.
    root.querySelectorAll('[data-open]').forEach(b => b.addEventListener('click', async () => {
      const r = (await data(true)).find(x => x.i === b.dataset.open);
      if (r && r.m) open(r.m[0].u, r.m[0].k);
    }));
    list.querySelectorAll('[data-helpful]').forEach(b => { if (votes.has(b.dataset.helpful)) b.setAttribute('aria-pressed', 'true'); });
    clampButtons(list);
    countUp(root);
  }

  // The big average counts up once when it scrolls into view.
  function countUp(root) {
    const el = root.querySelector('.lr-rv__avg'); if (!el || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const end = parseFloat(el.textContent); if (!end) return;
    const io = new IntersectionObserver(es => { if (!es[0].isIntersecting) return; io.disconnect();
      const t0 = performance.now(), d = 900;
      const step = t => { const k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3); el.textContent = (end * e).toFixed(1); if (k < 1) requestAnimationFrame(step); else el.textContent = end.toFixed(1); };
      requestAnimationFrame(step); }, { threshold: .6 });
    io.observe(el);
  }

  function carousel(root) {
    const track = root.querySelector('.lr-rvc__track');
    root.querySelectorAll('[data-dir]').forEach(b => b.addEventListener('click', () => {
      const step = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: Number(b.dataset.dir) * step, behavior: 'smooth' });
    }));
    viewer(root); helpful(root);
    clampButtons(root);
  }

  const start = () => {
    document.querySelectorAll('[data-lr-rv]:not([data-ready])').forEach(r => { r.dataset.ready = 1; init(r); });
    document.querySelectorAll('[data-lr-rvc]:not([data-ready])').forEach(r => { r.dataset.ready = 1; carousel(r); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
